import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { IStatement } from '../../../model/statement'
import statementStore from '../statement-store'

export default async function hideStatement(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    let statements = statementStore.state.statements
    statements.splice(statements.indexOf(statement), 1)

    return
}
